/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloudBox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z" />
    <path
      fill="#fff"
      d="M15 9a4.802 4.802 0 0 0-4.495 3.114l1.123.422A3.601 3.601 0 0 1 18.6 13.8a3.6 3.6 0 0 1-3.6 3.6H9a3.6 3.6 0 0 1-1.195-6.997 4.2 4.2 0 0 1 8.254-1.286A4.818 4.818 0 0 0 15 9Z"
    />
  </svg>
);

export default SvgCloudBox;
